import React, { FC } from 'react';
import { Tooltip } from '@material-ui/core';

/** Separator the API uses in `purchaseOrderNumbers` (creation order). */
export const PURCHASE_ORDER_NUMBERS_SEPARATOR = ', ';

export type PurchaseOrderRecord = {
  purchaseOrderNumber?: string | null;
  purchaseOrderCount?: number | null;
  purchaseOrderNumbers?: string | null;
};

type PurchaseOrderFieldProps = {
  record?: PurchaseOrderRecord;
  /** Read by the Datagrid header, as on any react-admin field. */
  source?: string;
  label?: string;
  sortable?: boolean;
};

/**
 * Purchase Order # cell of the Archived Jobs list: the number of the job's
 * earliest purchase order, followed by "+n" when the job has others. The
 * "+n" is a count, not a link; its tooltip lists the other numbers. A job
 * without a purchase order shows a dash, which is a normal state (a job
 * created after the Materials phase never had one).
 */
export const PurchaseOrderField: FC<PurchaseOrderFieldProps> = ({ record }) => {
  const first = record?.purchaseOrderNumber;
  if (!first) {
    return <span>-</span>;
  }

  const others = (record?.purchaseOrderNumbers ?? '')
    .split(PURCHASE_ORDER_NUMBERS_SEPARATOR)
    .slice(1);
  const extra = Math.max((record?.purchaseOrderCount ?? 1) - 1, others.length);

  return (
    <span>
      {first}
      {extra > 0 && (
        <Tooltip title={others.join(PURCHASE_ORDER_NUMBERS_SEPARATOR)}>
          <span
            data-cy="archivedJobsPurchaseOrderMore"
            style={{ marginLeft: 4, whiteSpace: 'nowrap' }}
          >
            +{extra}
          </span>
        </Tooltip>
      )}
    </span>
  );
};
